import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CxSchedularService } from '../cx-schedular.service';
import { Schedual } from '../types';
import { add, cloneDeep } from 'lodash';
import moment from 'moment';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'cx-schedular-creator',
  templateUrl: './cx-schedular-creator.component.html',
  styleUrl: './cx-schedular-creator.component.scss'
})
export class CxSchedularCreatorComponent implements OnInit, OnChanges, OnDestroy {
  SCREENS = this.cxSchedularService.SCREENS;
  minDate = new Date();
  emailValidMessage = "";
  @Input() module: string = '';
  @Input() views: any[] = [];
  __views = [];

  data: Schedual = {
    name: '',
    view_id: '',
    location: 'end',
    type: 'xlsx',
    cron_label: '10-minute',
    addresses: [],
    cron_expression: new Date(),
    module: ''
  }

  constructor(public cxSchedularService: CxSchedularService, public toast: ToastService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['views']){
      this.__views = cloneDeep(changes['views'].currentValue).map((x: any) => {
        if (x.showPined === false) {
          x.name = 'Select View';
        }
        return x;
      })
    }
  }

  ngOnDestroy(): void {
    this.cxSchedularService.editMode = false;
    this.cxSchedularService.edit_id = null;
  }
  
  ngOnInit(): void {
     if (!this.module) {
      throw new Error(`CxSchedular Module is required.`);
    }

    if (this.cxSchedularService.edit_id) {
      this.cxSchedularService.get(this.cxSchedularService.edit_id).subscribe((record: Schedual) => {
        record.cron_expression = moment(record.cron_expression).toDate();
        this.data = record;
      })
    }
  }

  onUpdate ($event: any) {
    let valid = true;
    if (this.data.location === 'end' && Array.isArray(this.data.addresses) && this.data.addresses.length > 0) {
      this.data.addresses.forEach((address: string) => {
        if (!this.isValidateEmail(address)) {
          valid = false;
        }
      })
    } else {
      if (Array.isArray(this.data.addresses) && this.data.addresses.length == 0) {
        this.emailValidMessage = 'Email is required.';
        return; 
      }
    }

    if (!valid) { 
      this.emailValidMessage = 'Email address is not valid'; 
      return; 
    } else {
      this.emailValidMessage = ''; 
    }

    if (!(this.data.name).trim()) {
      this.toast.error("Name is required.");
      return;
    }
    
    const payload: Schedual = {
      id: this.cxSchedularService.edit_id,
      name: this.data.name,
      location: this.data.location,
      type: this.data.type,
      addresses: this.data.addresses,
      module: this.module,
      cron_label: this.data.cron_label,
      cron_expression: this.data?.cron_expression ? String(this.data.cron_expression) : '',
      view_id: this.data.view_id,
    }
    this.cxSchedularService.update(payload).subscribe((x: any) => {
      this.cxSchedularService.getData();
      this.cxSchedularService.changeScreen(this.SCREENS.ONE);
    });
  }

  isValidateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  onCreate ($event: any) {
    let valid = true;
    if (this.data.location === 'end' && Array.isArray(this.data.addresses) && this.data.addresses.length > 0) {
      this.data.addresses.forEach((address: string) => {
        if (!this.isValidateEmail(address)) {
          valid = false;
        }
      })
    } else {
      if (Array.isArray(this.data.addresses) && this.data.addresses.length == 0) {
        this.emailValidMessage = 'Email is required.';
        return; 
      }
    } 

    if (!valid) { 
      this.emailValidMessage = 'Email address is not valid'; 
      return; 
    } else {
      this.emailValidMessage = ''; 
    }

    if (!(this.data.name).trim()) {
      this.toast.error("Name is required.");
      return;
    }

    const payload: Schedual = {
      name: this.data.name,
      location: this.data.location,
      type: this.data.type,
      addresses: this.data.addresses,
      module: this.module,
      cron_label: this.data.cron_label,
      cron_expression: this.data?.cron_expression ? String(this.data.cron_expression) : '',
      view_id: this.data.view_id,
    }
    this.cxSchedularService.create(payload).subscribe((x: any) => {
      this.cxSchedularService.getData();
      this.cxSchedularService.changeScreen(this.SCREENS.ONE);
    });
  }
}
